import script from "./ModifyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModifyButton.vue?vue&type=script&setup=true&lang=ts"

import "./ModifyButton.vue?vue&type=style&index=0&id=7d356066&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d356066"]])

export default __exports__